import script from "./StoryDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./StoryDetails.vue?vue&type=script&setup=true&lang=js"

import "./StoryDetails.vue?vue&type=style&index=0&id=253594d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-253594d7"]])

export default __exports__